import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'outline' | 'outlineAccent' | 'muted';
type PillButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
};
const variants: Record<Variant, string> = {
  primary: 'bg-pf-blue text-white hover:bg-pf-blue-hover disabled:bg-pf-blue/60',
  outline: 'border border-pf-line bg-white text-pf-ink hover:bg-pf-panel disabled:text-pf-faint disabled:hover:bg-white',
  outlineAccent: 'border border-pf-blue-line bg-white text-pf-blue hover:bg-pf-blue-soft',
  muted: 'bg-[#e3e4e6] text-pf-ink hover:bg-[#d7d9dc] disabled:text-[#a8acb1] disabled:hover:bg-[#e3e4e6]'
};
export const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(function PillButton({
  variant = 'outline',
  className,
  children,
  ...rest
}, ref) {
  return <button ref={ref} type="button" {...rest} className={twMerge('flex h-[24px] flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-full text-[12px] transition-colors duration-150 disabled:cursor-not-allowed', variants[variant], className)} data-id="element-867" data-mp="2xi6zbx82y4os">
      
      {children}
    </button>;
});